"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_state_1 = require("prosemirror-state");
var dom_1 = require("./dom");
var sylStateScope = new WeakMap();
// TODO: 去除这部分代码
var SylState = /** @class */ (function () {
    function SylState(proseState) {
        sylStateScope.set(this, proseState);
    }
    SylState.prototype.toJSON = function () {
        var proseState = unwrapSylState(this);
        return proseState.toJSON();
    };
    SylState.prototype.getSelection = function () {
        var proseState = unwrapSylState(this);
        return proseState.selection.toJSON();
    };
    SylState.prototype.traverse = function (walker) {
        var proseState = unwrapSylState(this);
        proseState.doc.descendants(function (node, pos, parent) {
            walker([node.type.name].concat(node.marks.map(function (mark) { return mark.type.name; }) || []), node.textContent || '', node.attrs);
        });
    };
    SylState.prototype.print = function () {
        // console.log(this.toJSON())
    };
    SylState.parseDOM = function (value, configuration) {
        if (typeof value === 'string') {
            value = dom_1.document.querySelector(value);
        }
        var doc = dom_1.DOMParser.fromSchema(configuration.schema).parse(value);
        var proseState = prosemirror_state_1.EditorState.create({
            schema: configuration.schema,
            plugins: configuration.plugins,
            doc: doc
        });
        return new SylState(proseState);
    };
    SylState.empty = function (configuratior) {
        var configuration = configuratior.configuration;
        var proseState = prosemirror_state_1.EditorState.create({
            schema: configuration.schema,
            plugins: configuration.plugins
        });
        return new SylState(proseState);
    };
    return SylState;
}());
exports.SylState = SylState;
function unwrapSylState(sylState) {
    var proseState = sylStateScope.get(sylState);
    if (!proseState) {
        throw new Error('loss proseState');
    }
    return proseState;
}
exports.unwrapSylState = unwrapSylState;
//# sourceMappingURL=state.js.map